export default "__VITE_ASSET__71af0095__"